import { config } from '../index';

const SCREEN_W = 1280;
const SCREEN_H = 720;

export default class FinalScene extends Phaser.Scene {
  constructor() {
    super({ key: 'FinalScene' });
  }

  preload() {
    this.load.image('endScreenOverlay', 'assets/EndScreenAssets/end screen.png');
    this.load.image('youWon', 'assets/EndScreenAssets/You Won.png');
    this.load.image('endNextButton', 'assets/EndScreenAssets/Button CTA.png');
    this.load.image('endNextHover', 'assets/EndScreenAssets/next hover.png');
    this.load.image('okayButton', 'assets/EndScreenAssets/okaybutton.png');
    this.load.image('okayHover', 'assets/EndScreenAssets/okayHover.png');
    this.load.image('okayDisabled', 'assets/EndScreenAssets/okayDisabled.png');
    this.load.image('rewardEarned', 'assets/EndScreenAssets/Rewards earned!.png');
    this.load.image('rewardName', 'assets/EndScreenAssets/Rectangle 13864.png');
    this.load.image('rewardCoins', 'assets/EndScreenAssets/coin.png');
    this.load.image('rewardStarA', 'assets/EndScreenAssets/Star 11.png');
    this.load.image('rewardStarB', 'assets/EndScreenAssets/Star 12.png');
    this.load.image('rewardCoinsLabel', 'assets/EndScreenAssets/coins.png');
    this.load.image('finalDoorBg', 'assets/EndSceneAssets/fbg.png');
    this.load.image('doorImage', 'assets/EndSceneAssets/DOOR0N.png');
    this.load.image('slot', 'assets/EndSceneAssets/slot.png');
    this.load.image('gem', 'assets/EndSceneAssets/gem.png');
    this.load.image('gem2', 'assets/EndSceneAssets/gem2.png');
    this.load.image('gem3', 'assets/EndSceneAssets/gem3.png');

    this.load.multiatlas(
      'spotlight',
      'assets/EndScreenAssets/spotlight/spotlightAnimNew.json',
      'assets/EndScreenAssets/spotlight',
    );
    this.load.multiatlas(
      'endConfetti',
      'assets/EndScreenAssets/confetti/confettiAnimNew.json',
      'assets/EndScreenAssets/confetti',
    );
    this.load.multiatlas(
      'finalDoorAnim',
      'assets/EndSceneAssets/Door animation/DoorAnim.json',
      'assets/EndSceneAssets/Door animation',
    );
  }

  create() {
    this.cameras.main.setBackgroundColor('#000000');
    this.cameras.main.fadeIn(400, 0, 0, 0);

    const bgMusic = config.audio && config.audio.bgAudio;
    if (bgMusic) {
      this.tweens.add({
        targets: bgMusic,
        volume: 0,
        duration: 1000,
        onComplete: () => bgMusic && bgMusic.destroy(),
      });
    }

    this.playDoorIntro();
  }

  playDoorIntro() {
    this.anims.create({
      key: 'finalDoorOpen',
      frames: this.anims.generateFrameNames('finalDoorAnim', {
        start: 0,
        end: 205,
        prefix: 'DOOR',
        suffix: '.png',
      }),
      frameRate: 45,
      repeat: 0,
    });

    this.doorBg = this.add.image(SCREEN_W / 2, SCREEN_H / 2, 'finalDoorBg').setDepth(999);

    this.doorOld = this.add
      .sprite(SCREEN_W / 2, SCREEN_H / 2, 'doorImage')
      .setScale(1.03)
      .setDepth(1000);

    this.slot = this.add.image(29, 24, 'slot').setOrigin(0, 0).setDepth(1001);

    this.gem1 = this.add.image(22, 18, 'gem').setOrigin(0, 0).setDepth(1002);
    this.gem2 = this.add.image(22, 85, 'gem2').setOrigin(0, 0).setDepth(1002);
    this.gem3 = this.add.image(22, 145, 'gem3').setOrigin(0, 0).setDepth(1002);

    this.doorSprite = this.add
      .sprite(SCREEN_W / 2, SCREEN_H / 2, 'finalDoorAnim')
      .setScale(1.03)
      .setVisible(false)
      .setDepth(1000);

    this.doorSprite.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'finalDoorOpen',
      () => this.flashThenShowReward(),
      this,
    );

    const doorAudio = this.sound.get('doorUnlock') || this.sound.add('doorUnlock');
    doorAudio.setVolume(0.4);

    const vanishGem = gem => {
      this.tweens.add({
        targets: gem,
        alpha: 0,
        scale: 0.6,
        ease: 'Sine.easeIn',
        duration: 350,
        onComplete: () => gem.setVisible(false),
      });
    };

    this.tweens.add({
      targets: this.gem1,
      x: 598,
      y: 217,
      ease: 'Power2',
      duration: 3000,
      delay: 500,
      onComplete: () => vanishGem(this.gem1),
    });
    this.tweens.add({
      targets: this.gem2,
      x: 558.5,
      y: 266,
      ease: 'Power2',
      duration: 3000,
      delay: 500,
      onComplete: () => vanishGem(this.gem2),
    });
    this.tweens.add({
      targets: this.gem3,
      x: 639.5,
      y: 266,
      ease: 'Power2',
      duration: 3000,
      delay: 500,
      onComplete: () => vanishGem(this.gem3),
    });

    this.time.delayedCall(3500, () => {
      this.doorOld.setVisible(false);
      this.doorSprite.setVisible(true).play('finalDoorOpen');
    });

    this.time.delayedCall(5000, () => {
      doorAudio.play();
    });
  }

  flashThenShowReward() {
    this.whiteFlash = this.add
      .rectangle(SCREEN_W / 2, SCREEN_H / 2, SCREEN_W, SCREEN_H, 0xffffff)
      .setAlpha(0)
      .setDepth(1100);

    this.tweens.add({
      targets: this.whiteFlash,
      alpha: 1,
      ease: 'Sine.easeIn',
      duration: 250,
      onComplete: () => {
        this.doorSprite.destroy();
        if (this.doorBg) this.doorBg.destroy();
        if (this.doorOld) this.doorOld.destroy();
        if (this.slot) this.slot.destroy();
        if (this.gem1) this.gem1.destroy();
        if (this.gem2) this.gem2.destroy();
        if (this.gem3) this.gem3.destroy();
        this.showRewardScreen();

        this.time.delayedCall(400, () => {
          this.tweens.add({
            targets: this.whiteFlash,
            alpha: 0,
            ease: 'Sine.easeOut',
            duration: 700,
            onComplete: () => this.whiteFlash.destroy(),
          });
        });
      },
    });
  }

  showRewardScreen() {
    this.endOverlay = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'endScreenOverlay');
    this.endOverlay.setDisplaySize(SCREEN_W, SCREEN_H);

    this.spotlight = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'spotlight');
    this.anims.create({
      key: 'spotlightOpen',
      frames: this.anims.generateFrameNames('spotlight', {
        start: 0,
        end: 188,
        zeroPad: 0,
        prefix: 'spotlight0',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.endConfetti = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'endConfetti');
    this.anims.create({
      key: 'endConfetti',
      frames: this.anims.generateFrameNames('endConfetti', {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.time.delayedCall(2000, () => this.spotlight.play('spotlightOpen'), [], this);

    this.youWon = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'youWon').setAlpha(0);
    this.tweens.add({
      targets: this.youWon,
      ease: 'Expo.easeInOut',
      duration: 1000,
      delay: 300,
      alpha: 1,
    });
    this.tweens.add({
      targets: this.youWon,
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      y: SCREEN_H / 2 - 50,
    });

    this.endConfetti.play('endConfetti');

    this.nextButton = this.add
      .sprite(SCREEN_W / 2, 740, 'endNextButton')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.tweens.add({
      targets: this.nextButton,
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      alpha: 1,
      y: 650,
    });

    this.reward = this.add
      .sprite(SCREEN_W / 2, SCREEN_H / 2, 'rewardCoins')
      .setScale(0)
      .setVisible(false)
      .setDepth(10);

    this.okButton = this.add
      .sprite(SCREEN_W / 2, 740, 'okayButton')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.nextButton.on('pointerover', () => this.nextButton.setTexture('endNextHover'));
    this.nextButton.on('pointerout', () => this.nextButton.setTexture('endNextButton'));

    this.nextButton.on('pointerup', () => {
      this.tweens.add({
        targets: [this.youWon, this.nextButton],
        alpha: 0,
        duration: 300,
      });

      this.time.delayedCall(
        1000,
        () => {
          this.reward.setVisible(true);
          this.tweens.add({
            targets: this.reward,
            scale: 1,
            angle: 360,
            ease: 'Back.easeOut',
            duration: 1200,
            onComplete: () => {
              this.tweens.add({
                targets: this.reward,
                scale: 1.08,
                ease: 'Sine.easeInOut',
                duration: 900,
                yoyo: true,
                repeat: -1,
              });
              this.tweens.add({
                targets: this.reward,
                y: SCREEN_H / 2 - 12,
                ease: 'Sine.easeInOut',
                duration: 1400,
                yoyo: true,
                repeat: -1,
              });
            },
          });

          this.rewardStars = [
            {
              tex: 'rewardStarA',
              x: SCREEN_W / 2 - 130,
              y: SCREEN_H / 2 - 70,
              delay: 200,
              twinkle: 700,
            },
            {
              tex: 'rewardStarB',
              x: SCREEN_W / 2 + 130,
              y: SCREEN_H / 2 - 40,
              delay: 450,
              twinkle: 850,
            },
            {
              tex: 'rewardStarA',
              x: SCREEN_W / 2 + 110,
              y: SCREEN_H / 2 + 70,
              delay: 350,
              twinkle: 750,
            },
            {
              tex: 'rewardStarB',
              x: SCREEN_W / 2 - 110,
              y: SCREEN_H / 2 + 50,
              delay: 600,
              twinkle: 800,
            },
          ].map(s => {
            const star = this.add
              .sprite(s.x, s.y, s.tex)
              .setScale(0)
              .setAlpha(0)
              .setDepth(11);
            this.tweens.add({
              targets: star,
              scale: 1,
              alpha: 1,
              angle: 180,
              ease: 'Back.easeOut',
              duration: 600,
              delay: s.delay,
              onComplete: () => {
                this.tweens.add({
                  targets: star,
                  scale: { from: 0.7, to: 1.15 },
                  alpha: { from: 0.6, to: 1 },
                  ease: 'Sine.easeInOut',
                  duration: s.twinkle,
                  yoyo: true,
                  repeat: -1,
                });
                this.tweens.add({
                  targets: star,
                  angle: '+=360',
                  ease: 'Linear',
                  duration: 4000,
                  repeat: -1,
                });
              },
            });
            return star;
          });

          this.add.sprite(581, 126, 'rewardEarned').setOrigin(0);
          this.add.sprite(SCREEN_W / 2, 360, 'rewardName').setOrigin(0.5);
          this.add
            .sprite(SCREEN_W / 2, 480, 'rewardCoinsLabel')
            .setOrigin(0.5)
            .setDepth(12);

          this.tweens.add({
            targets: this.okButton,
            ease: 'Linear',
            duration: 300,
            delay: 3000,
            alpha: 1,
            y: 650,
          });
        },
        [],
        this,
      );
    });

    this.okButton.on('pointerover', () => this.okButton.setTexture('okayHover'));
    this.okButton.on('pointerout', () => this.okButton.setTexture('okayButton'));
    this.okButton.on('pointerup', () => {
      this.okButton.setTexture('okayDisabled');
      this.okButton.removeInteractive();
    });
  }

  update() {}
}
